<template>
  <div
    class="fixed bottom-0 z-50 w-full p-12 md:right-0 md:w-auto md:px-18 md:py-24"
  >
    <RevCard v-if="shouldShowCard" class="p-24">
      <div class="mb-18 flex">
        <RevIllustration
          :alt="i18n(translations.altLabel)"
          class="mr-18"
          :height="35"
          src="/img/hotline.svg"
          :width="40"
        />
        <div class="flex-1">
          <h3 class="heading-3">
            {{ i18n(translations.modalTitle) }}
          </h3>
          <span class="body-1">
            {{ i18n(translations.modalSubtitle) }}
          </span>
        </div>
      </div>

      <div>
        <RevButton
          class="mr-18"
          size="small"
          variant="primary"
          @click="goToFeedbackPage"
        >
          {{ i18n(translations.sendFeedbackButton) }}
        </RevButton>
        <RevLink data-qa="notNowButton" variant="primary" @click="hideCard">
          {{ i18n(translations.notNowButton) }}
        </RevLink>
      </div>
    </RevCard>
  </div>
</template>

<script setup lang="ts">
import { navigateTo, useRoute } from '#imports'
import { onMounted, ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useLocalStorage } from '@backmarket/utils/composables/useLocalStorage'
import { RevButton } from '@ds/components/Button'
import { RevCard } from '@ds/components/Card'
import { RevIllustration } from '@ds/components/Illustration'
import { RevLink } from '@ds/components/Link'

import { ROUTE_NAMES } from '~/constants/routes'

import translations from './TheFeedbackPrompt.translations'

const GENERAL_FEEDBACK_FORM_ID = 'Xo0eL6Ti'
const LOCAL_STORAGE_FIELD_NAME = 'bo_merchant_feedback_modal'
const DAYS_COUNTER_WITHOUT_MODAL = 15

const shouldShowCard = ref(false)
const i18n = useI18n()
const localStorage = useLocalStorage()

onMounted(() => {
  const expirationDate = localStorage.getItem(LOCAL_STORAGE_FIELD_NAME)
  const isExpirationDateValid =
    expirationDate && !Number.isNaN(parseInt(expirationDate, 10))

  shouldShowCard.value = isExpirationDateValid
    ? Number(expirationDate) < Date.now()
    : true
})

function hideCard() {
  const currentDate = new Date()
  const expirationDate = currentDate.setDate(
    currentDate.getDate() + DAYS_COUNTER_WITHOUT_MODAL,
  )

  localStorage.setItem(LOCAL_STORAGE_FIELD_NAME, String(expirationDate))
  shouldShowCard.value = false
}

function goToFeedbackPage() {
  const route = useRoute()

  hideCard()

  navigateTo(
    {
      name: ROUTE_NAMES.FEEDBACK,
      query: {
        formId: GENERAL_FEEDBACK_FORM_ID,
        fromPath: route.fullPath,
      },
    },
    { external: true },
  )
}
</script>
